function Articles_initSurvey(article_id) {
    //$("input:radio[name=clanok_anketa]").on("click", function() {
    $("#okruhlygraf a").on("click", function () {

        ajax_call({
            module:"ArticlesSurvey",
            action:"vote",
            type:0,
            args:{
                "article_id":article_id,
                "vote":$(this).attr("vote")
                //"vote": $(this).val()
            }
        }, function (json) {
            if (typeof(json.error) != "undefined") {
                $.facebox("<h2>Hups!</h2><br>Pri načítavaní fotografie sa vyskytla chyba nasledujúca chyba: <b>" + json.error + "</b>");
                return;
            }

            $("#okruhlygraf").html(json.html).css("background", json.background);

        }, "json");

        return false;
    });
}
function Articles_reportMistake() {
    $("embed").css({"visibility":"hidden"});
    $.facebox($("#report_mistake").html());
    $(document).bind('close.facebox', function () {
        $("embed").css({"visibility":"visible"});
    });
}
function Articles_recommendArticle() {
    $("embed").css({"visibility":"hidden"});
    $.facebox($("#recommend_article").html());
    $(document).bind('close.facebox', function () {
        $("embed").css({"visibility":"visible"});
    });
}
function Articles_reportMistakeSend() {
    jQuery(document).trigger('close.facebox');
    ajax_call({
        module:"Articles",
        action:"reportMistake",
        type:0,
        args:{
            "url":REQUEST_URI,
            "g-recaptcha-response":$("#g-recaptcha-response").val(),
            "text":$(".articleerror-content:last").val()
        }
    }, function (data) {

    }, "html");
}
function Articles_recommendArticleSend() {
    jQuery(document).trigger('close.facebox');
    ajax_call({
        module:"Articles",
        action:"recommendArticle",
        type:0,
        args:{
            "url":REQUEST_URI,
            "from":$(".email_from:last").val(),
            "to":$(".email_to:last").val()
        }
    }, function (data) {

    }, "html");
}

function Articles_initChart(data) {
    var d = new Date();

    document.write("<div class=\"embedgrafu\">\n");
    document.write("<strong>" + data.name + "</strong>\n");
    document.write("<div id=\"Articles_articleChart_" + data.ID + "\"></div>\n");
    document.write("<a href=\"" + data.link + "\">Podrobnejšie informácie &raquo;</a>\n");
    document.write("</div>\n");

    $(document).ready(function () {
        $("#Articles_articleChart_" + data.ID).flash(
            {
                src:'/charts/charts.swf?library_path=/charts/charts_library&xml_source=/cache/charts/user-' + data.ID + '.xml?c=' + d.getTime(),
                width:520,
                height:350,
                fullscreen:"false"
            }, {
                version:8
            });
    });
}
function initTabbedPanel(panelId) {
    $("#" + panelId + " ul:first li").each(function (i, el) {
        $(this).find("a").on("click", function () {
            $("#" + panelId + " ul:first li a").removeClass("selected");
            $(this).addClass("selected");
            $("#" + panelId + " div.tabbedPanel:visible").fadeOut(250, function () {
                $("#" + panelId + " div.tabbedPanel:eq(" + i + ")").fadeIn(250);
            });

            return false;
        });
    });
}
function discussion_submitComment(article_id, page, type, nick) {
    $(".addingComment").show();
    $(".addcomment_input").attr("disabled", "disabled");
    ajax_call({
        module:"Discussions",
        action:"submitComment",
        type:0,
        args:{
            text:$("#discussion_comment_input").val(),
            type:type,
            id:article_id,
            page:page,
            nick:nick
        }
    }, function (data) {
        if (typeof(data.error) != "undefined") {
            /**
             * TODO: error message
             */
            alert("Nastala chyba pri pridávaní komentáru.");
            $(".addingComment").fadeOut();
            $(".addcomment_input").attr("disabled", false);
            return;
        }

        $(".addingComment").fadeOut();
        $(".addcomment_input").attr("disabled", false).val("");

        $(".strankovanie").html(data.pagination);
        $("#discussion_comments").append(data.comment);
        $("#commentrow_" + data.comment_id).hide().fadeIn("slow");

    }, "json");
}
function survey_voteinit(survey) {
    var vote = $(".survey_vote_option:checked").val();
    ajax_call({
        module:"Survey",
        action:"vote",
        type:0,
        args:{
            "vote":vote,
            "survey":survey
        }
    }, function (data) {
        $("#panel_survey").html(data);
    }, "html");
}
function ArticlesLive_refresh(articleId) {
    ajax_call({
        module:"ArticlesLive",
        action:"getLiveEvents",
        type:0,
        args:{
            articleId:articleId
        }
    }, function (data) {

        $(".stream").html(data.liveEvents);
        $(".score").html(data.score);
        $(".score_thirds").html(data.score_partial);
        $(".event_info").html(data.event_info);
        $(".hometeam_logo").attr("src", data.hometeam_logo);
        $(".awayteam_logo").attr("src", data.awayteam_logo);
        $(".hometeam_name").html(data.hometeam_name);
        $(".awayteam_name").html(data.awayteam_name);
        $(".leftscores p").html(data.hometeam_scores);
        $(".rightscores p").html(data.awayteam_scores);
        $(".players_leftteam p").html(data.hometeam_players);
        $(".players_rightteam p").html(data.awayteam_players);

        setTimeout(function () {
            ArticlesLive_refresh(articleId);
        }, 30000);
    }, "json");
}
